module.exports = __webpack_public_path__ + "img/pos-icon.a5716b7e.svg";